import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from './constants.service';
import { LeaveReasonsDashboard, NewLeaveReasonPost } from '@core/models/leave-reasons/leave-reasons-dashboard.model';
import { LeaveReasonAssignedEmployersPost, LeaveReasonDetails } from '@core/models/leave-reasons/leave-reason-details.model';
import { AssignedEmployersDialog } from '@core/models/shared/assigned-employers-dialog.model';
import { EditLeaveReasonInfoDialog, LeaveReasonInfoPost } from '@core/models/leave-reasons/edit-leave-reason-info-dialog.model';

@Injectable({
  providedIn: 'root'
})
export class LeaveReasonsService { 
	private apiUrl: string;

	constructor(private http: HttpClient, private constants: ConstantsService) {
		this.apiUrl = this.constants.LR_API;
	}

	public getLeaveReasonsDashboard(): Observable<LeaveReasonsDashboard> {
		return this.http.get<LeaveReasonsDashboard>(`${this.apiUrl}/getLeaveReasonsDashboard`);
	}

	public getLeaveReasonDetails(leaveReasonId: number): Observable<LeaveReasonDetails> {
		return this.http.get<LeaveReasonDetails>(`${this.apiUrl}/getLeaveReasonDetails/${leaveReasonId}`);
	}

	public getEditLeaveReasonInfoDialog(leaveReasonId: number): Observable<EditLeaveReasonInfoDialog> {
		return this.http.get<EditLeaveReasonInfoDialog>(`${this.apiUrl}/getEditLeaveReasonInfoDialog/${leaveReasonId}`);
	}

	public getEditLeaveReasonAssignedEmployersDialog(leaveReasonId: number): Observable<AssignedEmployersDialog> {
		return this.http.get<AssignedEmployersDialog>(`${this.apiUrl}/getEditLeaveReasonAssignedEmployersDialog/${leaveReasonId}`);
	}

	public postNewLeaveReason(dto: NewLeaveReasonPost): Observable<number> {
		return this.http.post<number>(`${this.apiUrl}/postNewLeaveReason`, dto);
	}

	public postLeaveReasonInfo(dto: LeaveReasonInfoPost): Observable<LeaveReasonDetails> {
		return this.http.post<LeaveReasonDetails>(`${this.apiUrl}/postLeaveReasonInfo`, dto);
	}

	public postLeaveReasonDelete(dto: {leaveReasonId: number}): Observable<LeaveReasonsDashboard> {
		return this.http.post<LeaveReasonsDashboard>(`${this.apiUrl}/postLeaveReasonDelete`, dto);
	}

	public postHideLeaveReason(dto: {leaveReasonId: number}): Observable<LeaveReasonsDashboard> {
		return this.http.post<LeaveReasonsDashboard>(`${this.apiUrl}/postHideLeaveReason`, dto);
	}

	public postUnhideLeaveReason(dto: {leaveReasonId: number}): Observable<LeaveReasonsDashboard> {
		return this.http.post<LeaveReasonsDashboard>(`${this.apiUrl}/postUnhideLeaveReason`, dto);
	}

	public postLeaveReasonAssignMyEmployer(dto: {leaveReasonId: number}): Observable<LeaveReasonDetails> { 
    return this.http.post<LeaveReasonDetails>(`${this.apiUrl}/postLeaveReasonAssignMyEmployer`, dto);
  }

  public postLeaveReasonUnassignMyEmployer(dto: {leaveReasonId: number}): Observable<LeaveReasonDetails> { 
    return this.http.post<LeaveReasonDetails>(`${this.apiUrl}/postLeaveReasonUnassignMyEmployer`, dto);
  }

	public postLeaveReasonAssignedEmployers(dto: LeaveReasonAssignedEmployersPost): Observable<LeaveReasonDetails> {
    return this.http.post<LeaveReasonDetails>(`${this.apiUrl}/postLeaveReasonAssignedEmployers`, dto)
  }
}